
const getERC20TokenList = async (mvcmydashboard) => {
	var  list = [];

	let sessionuuid = await mvcmydashboard.getCurrentSession();
	let bRefresh = true;
	let erc20tokens = await mvcmydashboard.getERC20Tokens(sessionuuid, bRefresh).catch(err => {});

	for (var i = 0; i < (erc20tokens ? erc20tokens.length : 0); i++) {
		let erc20token = erc20tokens[i];
		let record = {id: erc20token.uuid };

		record = Object.assign(record, erc20token);

		list.push(record);
	}

	return list;
};


export default {
	getFullList: async (mvcmydashboard) => {
		let list = [];

		if (!mvcmydashboard) return list;

		list = await getERC20TokenList(mvcmydashboard);

		return list;
	},

/*	getList: async (mvcmydashboard, params) => {
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;

		let list = [];

		if (!mvcmydashboard) return {data: list, total: list.length};

		list = await getERC20TokenList(mvcmydashboard);

		return {data: list, total: list.length};
	},

	getOne: async (mvcmydashboard, params) => {
		const { id } = params.id;

		let item = {id};

		if (!mvcmydashboard) return {data: item};

		let list = await getERC20TokenList(mvcmydashboard);

		for (var i = 0; i < (list ? list.length: 0); i++) {
			if (list[i] && list[i].id === id) {
				item = list[i];
				break;
			}
		}

		return {data: item}
	},*/

	getMany: async (mvcmydashboard, params) => {
		throw new Error('getMany not implemented');
	},

	getManyReference: async (mvcmydashboard, params) => {
		throw new Error('getManyReference not implemented');
	},

	update: async (mvcmydashboard, params) => {
		let erc20tokenuuid = params.id;
		let data = params.data;
		let localdescription = data.localdescription;

		if (!mvcmydashboard) return {data};

		let info = {localdescription};

		// local (not yet deployed) token
		if (data.localname) info.localname = data.localname;
		if (data.localsymbol) info.localsymbol = data.localsymbol;
		if (data.localdecimals) info.localdecimals = data.localdecimals;
		if (data.localtotalsupply) info.localtotalsupply = data.localtotalsupply;

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		let res = await mvcmydashboard.setERC20TokenInfo(sessionuuid, erc20tokenuuid, info);

		return {data};
	},

	updateMany: async (mvcmydashboard, params) => {
		throw new Error('updateMany not implemented');
	},

	create: async (mvcmydashboard, params) => {
		let data = params.data;
		let description = data.description;
		let tokeninfo = {description};

		let address = data.address;

		if (address) {
			// import
			tokeninfo.address = address;
		}
		else {
			// create
			tokeninfo.name = data.name;
			tokeninfo.symbol = data.symbol;
			tokeninfo.decimals = data.decimals;
			tokeninfo.totalsupply = data.totalsupply;
		}

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		let erc20token = await mvcmydashboard.createERC20Token(sessionuuid, tokeninfo);

		let record = {id: erc20token.uuid };

		record = Object.assign(record, erc20token);

		return {data: record};
	},

	delete: async (mvcmydashboard, params) => {
		let id = params.id;

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		return  mvcmydashboard.deleteERC20Token(sessionuuid, id);
	},

	deleteMany: async (mvcmydashboard, params) => {
		let ids = params.ids;

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		for (var i = 0; i < (ids ? ids.length : 0); i++) {
			await mvcmydashboard.deleteERC20Token(sessionuuid, ids[i]);
		}
	},
};